<template>
  <nav
    :class="[
      'menu',
      menuOpen ? '' : 'menu--close',
    ]"
  >
    <ul class="menu__container">
      <li
        class="menu__item"
        v-for="(voice, i) in menu"
        :key="i"
      >
        <router-link :to="voice.url">
          {{ voice.text }}
        </router-link>
      </li>
    </ul>
    <svg
      class="menu__logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 124"
    >
      <path class="logo__line" fill="none" stroke="black" d="M47.5,0L47.5,0c0,26.2-21.3,47.5-47.5,47.5h0"/>
      <path d="M67.8,58.4h0.9v2.9h4.1v-2.9h0.9v7.1h-0.9v-3.4h-4.1v3.4h-0.9V58.4z"/>
      <path d="M55.8,63.9c0.6,0.6,1.3,1,2.4,1c0.9,0,1.9-0.4,1.9-1.3c0-0.8-0.9-1.1-1.8-1.3c-1.3-0.3-2.6-0.7-2.6-2
        c0-1.2,1.2-1.9,2.5-1.9c1,0,1.7,0.3,2.4,0.8l-0.4,0.7c-0.6-0.4-1.3-0.7-2-0.7c-0.6,0-1.6,0.3-1.6,1.1s0.8,1,1.8,1.2
        c1.3,0.3,2.6,0.7,2.6,2.1c0,1.4-1.4,2.1-2.8,2.1c-1.3,0-2.2-0.5-2.8-1.1C55.4,64.6,55.8,63.9,55.8,63.9z"/>
      <path d="M42.5,58.4h0.9l3.4,4.4c0.5,0.6,0.9,1.4,0.9,1.4v-5.8h0.9v7.1h-0.9l-3.3-4.3c-0.5-0.7-1-1.5-1-1.5v5.7h-0.9
        C42.5,65.4,42.5,58.4,42.5,58.4z"/>
      <polygon points="100,58.4 97.3,58.4 96.5,58.4 93.8,58.4 93.8,59.2 96.5,59.2 96.5,65.5 97.3,65.5 97.3,59.2 100,59.2 "/>
      <path d="M31.9,65.6c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S33.9,65.6,31.9,65.6z M31.9,59c-1.6,0-2.9,1.3-2.9,2.9
        c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9C34.8,60.3,33.5,59,31.9,59z"/>
      <path d="M18,65.6c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S20,65.6,18,65.6z M18,59c-1.6,0-2.9,1.3-2.9,2.9
        c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9C20.9,60.3,19.6,59,18,59z"/>
      <polygon points="6.3,58.3 6.3,58.4 3.6,62.2 0.9,58.3 0.9,58.3 0.9,58.3 0,58.3 0,65.4 0.9,65.4 0.9,65.4 0.9,59.7 3.6,63.6 
        6.3,59.8 6.3,65.4 7.2,65.4 7.2,58.3 "/>
      <path d="M84.3,65.6c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S86.3,65.6,84.3,65.6z M84.3,59c-1.6,0-2.9,1.3-2.9,2.9
        c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9C87.2,60.3,85.9,59,84.3,59z"/>
      <path class="logo__line" fill="none" stroke="black" d="M52.5,124L52.5,124c0-26.2,21.3-47.5,47.5-47.5h0"/>
    </svg>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppBurger',
  data() {
    return {
      menu: [
        { text: 'HOME', url: '/' },
        { text: 'ABOUT', url: '/about' },
        { text: 'HOW WE WORK', url: '/how-we-work' },
        { text: 'AFFILIATES', url: '/affiliates' },
        { text: 'INSIGHTS', url: '/insights' },
        { text: 'CONTACT', url: '/contact' },
      ],
    };
  },
  computed: {
    ...mapState(['menuOpen']),
  },
};
</script>

<style lang="scss" scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-image: linear-gradient(0deg, #AF7778 0%, #141B38 89%);

  pointer-events: none;

  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-flow: column nowrap;

  @include mq(ipadL) {
    align-items: center;
    flex-flow: line wrap;
  }

  transition: opacity 0.8s $outQuint;

  &:not(.menu--close) .menu__container {
    list-style: none;
    pointer-events: all;
  }

  &__item {
    display: block;
    opacity: 1;
    transition: opacity 1s $outQuint 0.2s;
    padding: 0 0 0 30px;
    margin-bottom: 25px;

    backface-visibility: hidden;

    @include mq(ipadL) {
      display: inline-block;
      padding: 0 15px;
      margin-bottom: 0;
      opacity: 1;
      border-right: solid 1px rgba($color-white, 0.75);
      transition: opacity 1s $outQuint 0.2s;
    }

    @include mq(ds) {
      padding: 0 25px;
    }

    &:last-child {
      border-right: none;
    }

    a {
      position: relative;

      font-family: $font-family-heading;
      letter-spacing: 3px;
      color: $color-white;
      text-decoration: none;

      opacity: 0.75;
      transition: opacity 1s $outQuint 0.2s,
        letter-spacing 1s $outQuint 0.2s;

      &::before {
        content: '';

        position: absolute;
        bottom: -10px;
        left: 0;
        width: 100%;
        height: 1px;

        background-color: $color-white;
        transform-origin: 100% 50%;
        transform: scaleX(0);
        transition: transform 1s $outQuint;
      }


      &.router-link-exact-active {
        opacity: 1;

        @include mq($until: ipadL) {
          &::before {
            transform: scaleX(1);
          }
        }
      }

      @include mq($and: $is-not-touch-device) {
        &:hover {
          opacity: 1;

          &::before {
            transform-origin: 0 50%;
            transform: scaleX(1);
            background-color: rgba($color-white, 1);
          }
        }
      }
    }
  }

  &.menu--close {
    opacity: 0;

    .menu__item {
      opacity: 0;
      transition: opacity 1s $outQuint;

      a {
        opacity: 0;
        letter-spacing: 0;

        transition: opacity 1s $outQuint,
          letter-spacing 1s $outQuint 0.2s;
      }
    }

    & .menu__logo {
      opacity: 0;
      transition: opacity 0.5s $outQuint;

      .logo__line {
        stroke-dasharray: 74.6;
        stroke-dashoffset: 74.6;
      }
    }
  }

  &__logo {
    position: absolute;
    bottom: 50px;
    left: 50%;
    margin-left: -50px;
    width: 100px;

    transition: opacity 0.5s $outQuint 0.3s;

    path,
    polygon {
      display: inline-block;
      fill: white;
    }

    .logo__line {
      fill: none;
      stroke: white;
      stroke-dasharray: 74.6;
      stroke-dashoffset: 0;
      transition: stroke-dashoffset 1s $outQuint 0.3s;
    }
  }
}
</style>
